export function getToken(key) {
  return localStorage.getItem(key);
  // return Promise.resolve().then(function () {
  //   return localStorage.getItem(key);
  // });
}

export function setToken(key, value) {
  return localStorage.setItem(key, value);
  // return Promise.resolve().then(function () {
  //   localStorage.setItem(key, value);
  // });
}

export function removeToken(key, value) {
  return localStorage.removeItem(key, value);
  // return Promise.resolve().then(function () {
  //   localStorage.removeItem(key, value);
  // });
}
